import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './HomePage.css';

function HomePage() {
  const [showAllBrands, setShowAllBrands] = useState(false);  // State to manage brand visibility

  const toggleShowBrands = () => {
    setShowAllBrands(!showAllBrands);  // Toggle visibility
  };
  const [faq, setFaq] = useState([
    { question: "Where is the best place to buy a car?", answer: "You can buy a car from dealerships, online marketplaces, or directly from individuals.", isOpen: false },
    { question: "How do I check my credit score?", answer: "You can check your credit score through various online services or financial institutions.", isOpen: false },
    { question: "What is car finance?", answer: "Car finance is a way to spread the cost of a car over a period of time.", isOpen: false },
    // Add more FAQs here as needed
  ]);

  // --- Vehicle Search State and Logic ---
  const navigate = useNavigate();
  const [searchType, setSearchType] = useState('car');
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);

  // Fetch makes whenever searchType changes
  useEffect(() => {
    const fetchMakes = async () => {
      try {
        let allMakes = [];
        const types = ['car', 'van', 'truck'];
        if (searchType) {
          const res = await axios.get(`/api/vehicles/distinct/${searchType}`);
          allMakes = res.data.make;
        } else {
          for (const t of types) {
            const res = await axios.get(`/api/vehicles/distinct/${t}`);
            allMakes = allMakes.concat(res.data.make);
          }
        }
        setMakes(Array.from(new Set(allMakes)).sort());
      } catch (err) {
        console.error('Error fetching makes:', err);
      }
      // Reset dependent fields
      setMake('');
      setModel('');
      setModels([]);
    };
    fetchMakes();
  }, [searchType]);

  // Fetch models whenever make or searchType changes
  useEffect(() => {
    const fetchModels = async () => {
      if (!make) {
        setModels([]);
        setModel('');
        return;
      }
      try {
        let allModels = [];
        const types = ['car', 'van', 'truck'];
        if (searchType) {
          const res = await axios.get(`/api/vehicles/distinct/${searchType}?make=${encodeURIComponent(make)}`);
          allModels = res.data.model;
        } else {
          for (const t of types) {
            const res = await axios.get(`/api/vehicles/distinct/${t}?make=${encodeURIComponent(make)}`);
            allModels = allModels.concat(res.data.model);
          }
        }
        setModels(Array.from(new Set(allModels)).sort());
      } catch (err) {
        console.error('Error fetching models:', err);
      }
      setModel('');
    };
    fetchModels();
  }, [make, searchType]);

  const handleTypeChange = (e) => {
    setSearchType(e.target.value);
  };
  const handleMakeChange = (e) => {
    setMake(e.target.value);
  };
  const handleModelChange = (e) => {
    setModel(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    const queryParams = [];
    if (make) queryParams.push(`make=${encodeURIComponent(make)}`);
    if (model) queryParams.push(`model=${encodeURIComponent(model)}`);
    const query = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    navigate(`/${searchType}-search${query}`);
  };

  const toggleFaq = (index) => {
    setFaq(faq.map((item, i) => (i === index ? { ...item, isOpen: !item.isOpen } : item)));
  };
  
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>Search Cars, Vans & Trucks</h2>
          <form className="search-form" onSubmit={handleSearch}>
            <select name="searchType" value={searchType} onChange={handleTypeChange}>
              <option value="car">Cars</option>
              <option value="van">Vans</option>
              <option value="truck">Trucks</option>
            </select>
            <select name="make" value={make} onChange={handleMakeChange}>
              <option value="">Make</option>
              {makes.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
            <select name="model" value={model} onChange={handleModelChange} disabled={!make}>
              <option value="">Model</option>
              {models.map((mo) => (
                <option key={mo} value={mo}>{mo}</option>
              ))}
            </select>
            <button type="submit" className="cta-button">View Deals</button>
          </form>
        </div>
      </section>

      {/* Leasing Offers Section */}
      <section className="leasing-offers">
        <h2>Lease a Brand New Van</h2>
        <div className="offers-carousel">
          {/* Add individual offers as divs */}
          <div className="offer-card">Offer 1</div>
          <div className="offer-card">Offer 2</div>
          <div className="offer-card">Offer 3</div>
          {/* More offers */}
        </div>
        <Link to="/offers" className="view-all">View more deals</Link>
      </section>

      {/* Browse by Brand Section */}
      <section className="brands">
        <h2>Browse by brand</h2>
        <div className="brand-grid">
          <Link to="/car-search?make=Audi" className="brand-logo">
            <img src={require('../assets/logos/audi-logo.jpg')} alt="Audi Logo" />
            <span>Audi</span>
          </Link>
          <Link to="/car-search?make=BMW" className="brand-logo">
            <img src={require('../assets/logos/bmw-logo.jpg')} alt="BMW Logo" />
            <span>BMW</span>
          </Link>
          <Link to="/van-search?make=Ford" className="brand-logo">
            <img src={require('../assets/logos/ford-logo.jpg')} alt="Ford Logo" />
            <span>Ford</span>
          </Link>
          <Link to="/van-search?make=Mercedes-Benz" className="brand-logo">
            <img src={require('../assets/logos/mercedes-logo.jpg')} alt="Mercedes-Benz Logo" />
            <span>Mercedes-Benz</span>
          </Link>
          {/* Add more brands */}
          {showAllBrands && (
            <>
              <Link to="/car-search?make=Abarth" className="brand-logo">
                <img src={require('../assets/logos/abarth-logo.jpg')} alt="Abarth Logo" />
                <span>Abarth</span>
              </Link>
              <Link to="/car-search?make=Alfa%20Romeo" className="brand-logo">
                <img src={require('../assets/logos/alfaRomeo-logo.jpg')} alt="Alfa Romeo Logo" />
                <span>Alfa Romeo</span>
              </Link>
              <Link to="/van-search?make=Citroen" className="brand-logo">
                <img src={require('../assets/logos/citroen-logo.jpg')} alt="Citroen Logo" />
                <span>Citroen</span>
              </Link>
              <Link to="/car-search?make=Fiat" className="brand-logo">
                <img src={require('../assets/logos/fiat-logo.jpg')} alt="Fiat Logo" />
                <span>Fiat</span>
              </Link>
              <Link to="/car-search?make=Honda" className="brand-logo">
                <img src={require('../assets/logos/honda-logo.jpg')} alt="Honda Logo" />
                <span>Honda</span>
              </Link>
              <Link to="/car-search?make=Hyundai" className="brand-logo">
                <img src={require('../assets/logos/hyundai-logo.jpg')} alt="Hyundai Logo" />
                <span>Hyundai</span>
              </Link>
              <Link to="/car-search?make=Jaguar" className="brand-logo">
                <img src={require('../assets/logos/jaguar-logo.jpg')} alt="Jaguar Logo" />
                <span>Jaguar</span>
              </Link>
              <Link to="/car-search?make=Jeep" className="brand-logo">
                <img src={require('../assets/logos/jeep-logo.jpg')} alt="Jeep Logo" />
                <span>Jeep</span>
              </Link>
              <Link to="/car-search?make=Kia" className="brand-logo">
                <img src={require('../assets/logos/kia-logo.jpg')} alt="Kia Logo" />
                <span>Kia</span>
              </Link>
              <Link to="/van-search?make=Landrover" className="brand-logo">
                <img src={require('../assets/logos/landRover-logo.jpg')} alt="Land Rover Logo" />
                <span>Land Rover</span>
              </Link>
              <Link to="/car-search?make=Lexus" className="brand-logo">
                <img src={require('../assets/logos/lexus-logo.jpg')} alt="Lexus Logo" />
                <span>Lexus</span>
              </Link>
              <Link to="/van-search?make=Maxus" className="brand-logo">
                <img src={require('../assets/logos/maxus-logo.jpg')} alt="Maxus Logo" />
                <span>Maxus</span>
              </Link>
              <Link to="/car-search?make=Mazda" className="brand-logo">
                <img src={require('../assets/logos/mazda-logo.jpg')} alt="Mazda Logo" />
                <span>Mazda</span>
              </Link>
              <Link to="/car-search?make=MG" className="brand-logo">
                <img src={require('../assets/logos/mg-logo.jpg')} alt="MG Logo" />
                <span>MG</span>
              </Link>
              <Link to="/car-search?make=Mini" className="brand-logo">
                <img src={require('../assets/logos/mini-logo.jpg')} alt="Mini Logo" />
                <span>Mini</span>
              </Link>
              <Link to="/car-search?make=Mitsubishi" className="brand-logo">
                <img src={require('../assets/logos/mitsubishi-logo.jpg')} alt="Mitsubishi Logo" />
                <span>Mitsubishi</span>
              </Link>
              <Link to="/van-search?make=Nissan" className="brand-logo">
                <img src={require('../assets/logos/nissan-logo.jpg')} alt="Nissan Logo" />
                <span>Nissan</span>
              </Link>
              <Link to="/van-search?make=Peugeot" className="brand-logo">
                <img src={require('../assets/logos/peugeot-logo.jpg')} alt="Peugeot Logo" />
                <span>Peugeot</span>
              </Link>
              <Link to="/car-search?make=Polestar" className="brand-logo">
                <img src={require('../assets/logos/polestar-logo.jpg')} alt="Polestar Logo" />
                <span>Polestar</span>
              </Link>
              <Link to="/car-search?make=Porsche" className="brand-logo">
                <img src={require('../assets/logos/porsche-logo.jpg')} alt="Porsche Logo" />
                <span>Porsche</span>
              </Link>
              <Link to="/van-search?make=Renault" className="brand-logo">
                <img src={require('../assets/logos/renault-logo.jpg')} alt="Renault Logo" />
                <span>Renault</span>
              </Link>
              <Link to="/car-search?make=Seat" className="brand-logo">
                <img src={require('../assets/logos/seat-logo.jpg')} alt="Seat Logo" />
                <span>Seat</span>
              </Link>
              <Link to="/car-search?make=Skoda" className="brand-logo">
                <img src={require('../assets/logos/skoda-logo.jpg')} alt="Skoda Logo" />
                <span>Skoda</span>
              </Link>
              <Link to="/car-search?make=Smart" className="brand-logo">
                <img src={require('../assets/logos/smart-logo.jpg')} alt="Smart Logo" />
                <span>Smart</span>
              </Link>
              <Link to="/car-search?make=Subaru" className="brand-logo">
                <img src={require('../assets/logos/subaru-logo.jpg')} alt="Subaru Logo" />
                <span>Subaru</span>
              </Link>
              <Link to="/car-search?make=Suzuki" className="brand-logo">
                <img src={require('../assets/logos/suzuki-logo.jpg')} alt="Suzuki Logo" />
                <span>Suzuki</span>
              </Link>
              <Link to="/car-search?make=Tesla" className="brand-logo">
                <img src={require('../assets/logos/tesla-logo.jpg')} alt="Tesla Logo" />
                <span>Tesla</span>
              </Link>
              <Link to="/car-search?make=Toyota" className="brand-logo">
                <img src={require('../assets/logos/toyota-logo.jpg')} alt="Toyota Logo" />
                <span>Toyota</span>
              </Link>
              <Link to="/van-search?make=Vauxhall" className="brand-logo">
                <img src={require('../assets/logos/vauxhall-logo.jpg')} alt="Vauxhall Logo" />
                <span>Vauxhall</span>
              </Link>
              <Link to="/van-search?make=Volkswagen" className="brand-logo">
                <img src={require('../assets/logos/volkswagen-logo.jpg')} alt="Volkswagen Logo" />
                <span>Volkswagen</span>
              </Link>
              <Link to="/car-search?make=Volvo" className="brand-logo">
                <img src={require('../assets/logos/volvo-logo.jpg')} alt="Volvo Logo" />
                <span>Volvo</span>
              </Link>
              {/* Add more brand logos here */}
            </>
          )}
        </div>
        <button onClick={toggleShowBrands} className="view-all-brands-btn">
          {showAllBrands ? 'Hide all brands' : 'Show all brands'}
        </button>
      </section>

      {/* Buying Essentials */}
      <section className="buying-essentials">
        <h2>Buying essentials</h2>
        <div className="essentials-grid">
          <div className="essential-card">What is HP?</div>
          <div className="essential-card">Request Advice</div>
          <div className="essential-card">Car Finance Guide</div>
          <div className="essential-card">Check a car's history</div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq">
        <h2>Your questions answered</h2>
        {faq.map((item, index) => (
          <div
            key={index}
            className="faq-item"
            onClick={() => toggleFaq(index)}
          >
            <div className="faq-question">
              <span className="question-text">{item.question}</span>
              <span className={`faq-arrow ${item.isOpen ? 'open' : ''}`}></span>
            </div>
            {item.isOpen && <div className="faq-answer">{item.answer}</div>}
          </div>
        ))}
      </section>
    </div>
  );
}

export default HomePage;
